type DayLike = {
  start_time: string;
  end_time: string;
  break_duration_minutes?: number | string | null;
};

export const calculateDayMinutes = (day: DayLike): number => {
  if (!day.start_time || !day.end_time) return 0;

  const [startH, startM] = day.start_time.split(":").map(Number);
  const [endH, endM] = day.end_time.split(":").map(Number);

  if ([startH, startM, endH, endM].some((n) => Number.isNaN(n))) return 0;

  const totalMinutes = endH * 60 + endM - (startH * 60 + startM);
  const breakMinutes = Number(day.break_duration_minutes) || 0;

  return Math.max(0, totalMinutes - breakMinutes);
};

export const calculateWeeklyMinutes = (days: DayLike[]): number =>
  days.reduce((sum, day) => sum + calculateDayMinutes(day), 0);

export const formatMinutesAsHours = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return minutes > 0 ? `${hours}h${String(minutes).padStart(2, "0")}min` : `${hours}h`;
};
